import { useEffect, useState } from 'react'

import {
  getMockUserCoordsStorage,
  type UserCoords,
} from '../../shared/utils/loadMockUserCoords.utils'
import { getNearestLocation, LocationInfo } from './utils/getNearestCity'

export function useMockLocation() {
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [coords, setCoords] = useState<UserCoords | null>(null)
  const [nearestLocation, setNearestLocation] = useState<LocationInfo | null>(
    null
  )

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    const lat = params.get('lat')
    const lng = params.get('lng')

    const mockLSCoords = getMockUserCoordsStorage()

    let detectedCoords: UserCoords | null = null

    if (lat && lng) {
      detectedCoords = {
        latitude: Number(lat),
        longitude: Number(lng),
      }
    } else if (mockLSCoords) {
      detectedCoords = mockLSCoords
    }

    if (detectedCoords) {
      setCoords(detectedCoords)

      getNearestLocation(
        detectedCoords.latitude,
        detectedCoords.longitude
      ).then(setNearestLocation)

      setShowAlert(true)
    }
  }, [])

  const clearMockLocation = () => {
    setShowAlert(false)
    setCoords(null)
    setNearestLocation(null)
  }

  return {
    showAlert,
    coords,
    nearestLocation,
    hasMockLocation: !!coords,
    clearMockLocation,
  }
}
